class FAQItem extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('.faq-toggle');
    this.content = this.querySelector('.faq-content');
    this.arrow = this.querySelector('.faq-arrow');
    this.open = false;
    this.toggle.addEventListener('click', this.toggleContent.bind(this));
  }

  toggleContent() {
    this.open = !this.open;

    if (this.open) {
      this.content.style.maxHeight = this.content.scrollHeight + 'px';
      this.arrow.classList.add('rotate-180');
    } else {
      this.content.style.maxHeight = '0px';
      this.arrow.classList.remove('rotate-180');
    }
  }
}

customElements.define('faq-item', FAQItem);